export const SNACKBAR_DURATION = 5000
